<template>
    <div>
        <div style="width: 100vw;height: 28rem; overflow-y: scroll;">
        <div class="lockbox" v-for="(item,input) in locklist" @click="$router.push({
         name: 'Merchandise_page',
         params:{ name:item.name}})"> 
            <img :src="item.img" alt="" srcset="">
            <div style="color: #fff;font-size: 10px;width: 5rem;text-align: center;">{{item.name}}</div>
        </div>
        </div>
    </div>
</template>
<script>
import lock1 from '../img/lock1.png'
import lock2 from '../img/lock2.png'
import lock3 from '../img/lock3.png'
import lock4 from '../img/lock4.png'
import lock5 from '../img/lock5.png'
import lock6 from '../img/lock6.png'
import lock7 from '../img/lock7.png'
import lock8 from '../img/lock8.png'
import lock9 from '../img/lock9.png'
import lock10 from '../img/lock10.png'
import lock11 from '../img/lock11.png'
import lock12 from '../img/lock12.png'
import lock13 from '../img/lock13.png'
import lock14 from '../img/lock14.png'
import lock15 from '../img/lock15.png'
import lock16 from '../img/lock16.png'
import lock17 from '../img/lock17.png'
import lock18 from '../img/lock18.png'
import lock19 from '../img/lock19.png'
import lock20 from '../img/lock20.png'
import lock21 from '../img/lock21.png'
import lock22 from '../img/lock22.png'
import lock23 from '../img/lock23.png'
import lock24 from '../img/lock24.png'
export default{
    name:"smartlockseries",
    data() {
        return {
         locklist:[{img:lock1,name:'M1'},{img:lock2,name:'P8'},{img:lock3,name:'X1'},{img:lock4,name:'X3'}
         ,{img:lock5,name:'X5'},{img:lock6,name:'X6'},{img:lock7,name:'F10'},{img:lock8,name:'RL01'},{img:lock9,name:'K1'},
         {img:lock10,name:'K1 PRO'}, {img:lock11,name:'F(M)007-0A'},{img:lock12,name:'R1'},{img:lock13,name:'Q1'},{img:lock14,name:'BD01'}
         ,{img:lock15,name:'D01'},{img:lock16,name:'D02'},{img:lock17,name:'D04'},{img:lock18,name:'E04'},{img:lock19,name:'B01'},{img:lock20,name:'FY06'}
        ,{img:lock21,name:'FY07'},{img:lock22,name:'R2'},{img:lock23,name:'FY08'},{img:lock24,name:'FY09'}
        ]   
        }
    },
}
</script>
<style scoped>
.lockbox{
    cursor: pointer;
    width: 6vw;
    height: 10rem;
    padding-top: 2rem;
    display: inline-block;
    padding-left: 2vw;
    padding-right: 2vw;
}
.lockbox img:hover{
    background-color: #ffffff42;
}
.lockbox img{
    width: 5rem;
    height: 5rem;
}
@media screen and (max-width: 600px) {
    .lockbox{
    cursor: pointer;
    width: 20vw;
    height: 10rem;
    padding-top: 2rem;
    display: inline-block;
    padding-left: 2vw;
    padding-right: 2vw;
}
.lockbox img:hover{
    background-color: #ffffff42;
}
.lockbox img{
    width: 20vw;
    height: 20vw;
}
}
</style>